import { render, staticRenderFns } from "./TrText.vue?vue&type=template&id=9cd97d4e&"
import script from "./TrText.vue?vue&type=script&lang=js&"
export * from "./TrText.vue?vue&type=script&lang=js&"
import style0 from "./TrText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports